// Tenant permission constants (mirror backend accounts.permissions)
export const TENANT_VIEW = 'tenant.view';
export const TENANT_MANAGE = 'tenant.manage';
export const MEMBER_VIEW = 'member.view';
export const MEMBER_INVITE = 'member.invite';
export const MEMBER_REMOVE = 'member.remove';
export const MEMBER_MANAGE_ROLES = 'member.manage_roles';
export const PROJECT_VIEW = 'project.view';
export const PROJECT_CREATE = 'project.create';
export const JOB_VIEW = 'job.view';
export const JOB_CREATE = 'job.create';
export const JOB_CANCEL = 'job.cancel';
export const ARTIFACT_VIEW = 'artifact.view';
export const WORKER_VIEW = 'worker.view';
export const API_KEY_VIEW = 'api_key.view';
export const API_KEY_CREATE = 'api_key.create';
export const API_KEY_ROTATE = 'api_key.rotate';
export const API_KEY_REVOKE = 'api_key.revoke';
export const USAGE_VIEW = 'usage.view';
export const AUDIT_VIEW = 'audit.view';
export const BILLING_VIEW = 'billing.view';
export const BILLING_MANAGE = 'billing.manage';
export const SUBSCRIPTION_VIEW = 'subscription.view';
export const SUBSCRIPTION_MANAGE = 'subscription.manage';
export const PAYMENT_METHOD_VIEW = 'payment_method.view';
export const INVOICE_VIEW = 'invoice.view';
export const AI_TECHNICAL_ARTIST_USE = 'ai_technical_artist.use';
export const AI_TECHNICAL_ARTIST_VIEW = 'ai_technical_artist.view_conversations';
export const SOURCE_CONNECTION_VIEW = 'project_source_connection.view';
export const SOURCE_CONNECTION_CREATE = 'project_source_connection.create';
export const SOURCE_CONNECTION_UPDATE = 'project_source_connection.update';
export const SOURCE_CONNECTION_ROTATE_SECRET = 'project_source_connection.rotate_secret';
export const SOURCE_CONNECTION_TEST = 'project_source_connection.test';
export const SOURCE_CONNECTION_DELETE = 'project_source_connection.delete';
export const REVISION_CREATE_FROM_SOURCE = 'revision.create_from_source_control';
export const PROJECT_RIG_MEMORY_VIEW = 'project_rig_memory.view';
export const PROJECT_RIG_MEMORY_CREATE = 'project_rig_memory.create';
export const PROJECT_RIG_MEMORY_UPDATE = 'project_rig_memory.update';
export const CHARACTER_RIG_VIEW = 'character_rig.view';
export const CHARACTER_RIG_CREATE = 'character_rig.create';
export const CHARACTER_RIG_MEMORY_VIEW = 'character_rig_memory.view';
export const CHARACTER_RIG_MEMORY_PUBLISH = 'character_rig_memory.publish';
export const RIGGING_JOB_CREATE = 'rigging_job.create';
export const RIGGING_JOB_VIEW = 'rigging_job.view';

// Platform permission constants
export const PLATFORM_ACCESS = 'platform.access';
export const PLATFORM_TENANT_VIEW = 'platform.tenant.view';
export const PLATFORM_TENANT_MANAGE = 'platform.tenant.manage';
export const PLATFORM_TENANT_SUSPEND = 'platform.tenant.suspend';
export const PLATFORM_USER_VIEW = 'platform.user.view';
export const PLATFORM_JOB_VIEW = 'platform.job.view';
export const PLATFORM_WORKER_VIEW = 'platform.worker.view';
export const PLATFORM_WORKER_MANAGE = 'platform.worker.manage';
export const PLATFORM_POLICY_VIEW = 'platform.policy.view';
export const PLATFORM_AUDIT_VIEW = 'platform.audit.view';
export const PLATFORM_SETTINGS_VIEW = 'platform.settings.view';
export const PLATFORM_DEV_WORKER = 'platform.dev_worker';

export function hasTenantPermission(granted, permission) {
  if (!granted || !permission) return false;
  const bag = Array.isArray(granted) ? granted : [...granted];
  return bag.includes(permission);
}

export function hasPlatformPermission(granted, permission) {
  if (!granted || !permission) return false;
  const bag = Array.isArray(granted) ? granted : [...granted];
  return bag.includes(permission);
}

export function hasAnyTenantPermission(granted, permissions) {
  return permissions.some((p) => hasTenantPermission(granted, p));
}

export function hasAnyPlatformPermission(granted, permissions) {
  return permissions.some((p) => hasPlatformPermission(granted, p));
}
